import React, { useMemo, useState } from "react";
import {
  FaTimes,
  FaSearch,
  FaChevronDown,
  FaChevronRight,
  FaCheckCircle,
} from "react-icons/fa";

const PermissionDrawer = ({permissions = [],roleName = "",onClose,}) => {
  const [search, setSearch] = useState("");
  const [expanded, setExpanded] = useState({});

  const groupedPermissions = useMemo(() => {
      const grouped = {};
      permissions.forEach((permission) => {
        const module = permission.module || "General";
        if (!grouped[module]) {
          grouped[module] = {};
        }
        const entity = permission.entity;
        if (!grouped[module][entity]) {
          grouped[module][entity] = [];
        }
        grouped[module][entity].push(permission.action);
      });
      return grouped;
    }, [permissions]);

  const toggleSection = (module) => {
    setExpanded((prev) => ({
      ...prev,
      [module]:!prev[module],
    }));

  };

  return (
    <div className="fixed inset-0 z-50 bg-black/40">
      <div className="absolute right-0 top-0 h-full w-full max-w-lg overflow-y-auto bg-white shadow-xl">

        {/* Header */}
        <div className="flex items-center justify-between border-b px-6 py-5">
          <div>
            <h2 className="text-xl font-semibold">
              Role Permissions
            </h2>

            <p className="text-sm text-gray-500">
              {roleName}
            </p>
          </div>

          <button
            onClick={onClose}
            className="rounded-lg p-2 hover:bg-gray-100"
          >
            <FaTimes />
          </button>
        </div>

        {/* Search */}
        <div className="border-b p-5">
          <div className="relative">
            <FaSearch
              className="absolute left-3 top-3 text-gray-400"
            />

            <input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search module or entity..."
              className="w-full rounded-lg border py-2 pl-10 pr-3"
            />
          </div>
        </div>

        {/* Permission Groups */}
        <div className="p-5 space-y-4">
          {Object.keys(groupedPermissions)
            .filter((module) => module
                .toLowerCase()
                .includes(search.toLowerCase())
            ).map((module) => (
              <div
                key={module}
                className="rounded-lg border"
              >

                <button
                  onClick={() => toggleSection(module)}
                  className="flex w-full items-center justify-between bg-gray-50 px-4 py-3"
                >

                  <span className="font-semibold">
                    {module}
                  </span>

                  {expanded[module]
                    ? <FaChevronDown />
                    : <FaChevronRight />
                  }
                </button>

                {expanded[module] && (
                  <div className="p-4 space-y-4">
                    {Object.keys(groupedPermissions[module]).map(
                      (entity) => (
                        <div key={entity}>
                          <div className="mb-2 font-medium capitalize">
                            {entity}
                          </div>

                          <div className="flex flex-wrap gap-2">
                            {groupedPermissions[module][entity].map(
                              (action) => (
                                <span
                                  key={action}
                                  className="flex items-center gap-2 rounded-full bg-green-100 px-3 py-1 text-sm text-green-700"
                                >
                                  <FaCheckCircle />
                                  {action}
                                </span>
                              )
                            )}
                          </div>
                        </div>
                      )
                    )}
                  </div>
                )}
              </div>
            ))}

          {permissions.length === 0 && (
            <div className="py-10 text-center text-gray-500">
              No Permissions Assigned
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PermissionDrawer;